import { Flex, Box, TextV2 } from '@withjoy/joykit';
import React from 'react';
import { StarFilled } from '@withjoy/joykit/icons';
import { GuestSiteTypographyOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride';
import { useFeatureValue } from '@shared/core/featureFlags';
import { body1ToParagraphOverride } from '@apps/guest/components/GuestSiteTypographyOverride/GuestSiteTypographyOverride.constants';
import { DistanceFromVenue } from '@shared/components/DistanceFromVenue';

export const AccommodationTileSubtitle: React.FC<{
  starRating: Maybe<number>;
  distance?: number | null;
}> = ({ starRating, distance }) => {
  const fontPackExperimentEnabled = useFeatureValue('fontPackExperiment').value === 'treatment';

  return (
    <Flex
      flexDirection={'row'}
      paddingTop={1}
      justifyContent={'space-between'}
    >
      <DistanceFromVenue
        milesToVenue={distance}
        useInterUI={!fontPackExperimentEnabled}
      />
      {starRating && (
        <Flex alignItems="center">
          <Box paddingRight={1}>
            <StarFilled size={16} />
          </Box>
          <GuestSiteTypographyOverride
            override={body1ToParagraphOverride}
            defaultFontFamily="Inter UI"
          >
            <TextV2
              typographyVariant={'body1'}
              alignSelf={'center'}
              {...(!fontPackExperimentEnabled && { fontFamily: 'Inter UI' })}
            >
              {starRating}
            </TextV2>
          </GuestSiteTypographyOverride>
        </Flex>
      )}
    </Flex>
  );
};
